import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=454454c4"
import script from "./EmailSent.vue?vue&type=script&lang=js"
export * from "./EmailSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports